const topicItems = [
  { label: '网红翻车', count: '326条', hot: true },
  { label: '直播爆料', count: '289条', hot: true },
  { label: '娱乐圈内幕', count: '254条', hot: true },
  { label: '综艺现场', count: '198条', hot: false },
  { label: '素人投稿', count: '176条', hot: true },
  { label: '主播黑料', count: '165条', hot: false },
  { label: 'CP塌房', count: '142条', hot: false },
  { label: '品牌翻车', count: '128条', hot: true },
  { label: '音乐节事故', count: '96条', hot: false },
  { label: '短剧争议', count: '83条', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            大家都在搜
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            点击话题标签，发现更多相关吃瓜视频内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic, i) => (
            <a
              key={i}
              href="#index"
              className="inline-flex items-center gap-2 bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50 rounded-full px-4 py-2.5 transition-colors cursor-pointer group"
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-md whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}